import AnimatedPage from "@/components/AnimatedPage";
import CableTiles from "@/components/dashboard/CableTiles";
import BuyCableForm from "@/components/forms/BuyCableForm";
import HeaderBox from "@/components/HeaderBox";
import HelmetMetaData from "@/components/HelmetMetaData";
import Spinner from "@/components/Spinner";
import Unavailable from "@/components/Unavailable";
import { GetRequest } from "@/lib/http";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { toast } from "sonner";

const BuyCable = () => {
  const data = {};
  const user = useSelector((state) => state.user.user);
  const [loading, setLoading] = useState(true);
  const [plans, setPlans] = useState([]);

  const location = useLocation();
  const beneficiaryData = location.state;

  async function getPlans() {
    const { data, err } = await GetRequest({
      url: "/api/cable-details",
      setState: setLoading,
    });
    if (!err) {
      setPlans(data);
    } else {
      toast.error(err);
    }
  }

  useEffect(() => {
    getPlans();
  }, []);

  if (!user?.meta_data?.cable_active)
    return (
      <div className="p-3 sm:p-5">
        <div className="flex flex-col-reverse items-start justify-between md:flex-row">
          <HeaderBox
            title="Activate Cable Subscription"
            subtext="Access top channels with DStv, GOtv, and StarTimes. Enjoy endless entertainment at your fingertips!"
          />

          <div>
            <h2 className="text-sm font-medium">
              <Link to="/dashboard" className="hover:underline">
                Dashboard
              </Link>

              <span className="px-2 text-xl font-thin">/</span>

              <span className="text-gray-400">Cable Subscription</span>
            </h2>
          </div>
        </div>

        <CableTiles />

        <div className="mt-20">
          <Unavailable />
        </div>
      </div>
    );

  return (
    <AnimatedPage>
      <HelmetMetaData
        title="Subscribe to Cable Services - DStv, GOtv, StarTimes etc"
        description="Enjoy your favorite shows with our easy cable service subscriptions. Buy cable packages online and stay entertained with the best channels!"
      />

      {!loading ? (
        <section className="p-3 sm:p-5">
          <div className="flex flex-col-reverse items-start justify-between md:flex-row">
            <HeaderBox
              title="Activate Cable Subscription"
              subtext="Access top channels with DStv, GOtv, and StarTimes. Enjoy endless entertainment at your fingertips!"
            />

            <div>
              <h2 className="text-sm font-medium">
                <Link to="/dashboard" className="hover:underline">
                  Dashboard
                </Link>

                <span className="px-2 text-xl font-thin">/</span>

                <span className="text-gray-400">Cable Subscription</span>
              </h2>
            </div>
          </div>

          <CableTiles />
          <BuyCableForm
            metadata={data}
            allPlans={plans}
            beneficiaryData={beneficiaryData}
          />
        </section>
      ) : (
        <div className="align-center flex h-[100vh] flex-col justify-center">
          <Spinner />
          {/* <p className="text-center">Loading</p> */}
        </div>
      )}
    </AnimatedPage>
  );
};

export default BuyCable;
